import { Component, Input, inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { InvoluntaryRetrenchmentService } from 'src/app/core/services/involuntary-retrenchment.service';
import { ReportTabBase } from '../report-tab.base';

@Component({
    selector: 'app-involuntary-report',
    templateUrl: './involuntary-report.component.html',
    styleUrl: '../report-tab.scss',
})
export class InvoluntaryReportComponent extends ReportTabBase {
    @Input() policyStatuses: any[] = [];
    @Input() users: any[] = [];
    @Input() canFilterByUser = false;

    private readonly involuntaryRetrenchmentService = inject(InvoluntaryRetrenchmentService);

    readonly form = new FormGroup({
        startDate: new FormControl(),
        endDate: new FormControl(),
        user: new FormControl(),
        status: new FormControl(),
    });

    reports: any[] = [];

    submit(): void {
        const value = this.form.getRawValue();
        const payload = {
            startDate: this.toReportDate(value.startDate),
            endDate: this.toReportDate(value.endDate),
            userId: value.user,
            partnerId: null,
            status: value.status,
        };

        this.startLoading('Creating Report');
        this.involuntaryRetrenchmentService.generateReport(payload).subscribe({
            next: (response) => {
                this.reports = response.policyList;
                this.stopLoading();
            },
            error: (err) => {
                this.showError(err.error.message);
                this.stopLoading();
            },
        });
    }

    export(): void {
        this.exportTable('Involuntary_Retrenchment_Report');
    }
}
